export class ValidationErrorModel {
  property: string;
  message: string;
}

export class ValidationResultModel {
  entityId?: number;
  isValid: boolean;
  errors: ValidationErrorModel[];
}



// WEBPACK FOOTER //
// ./src/_foundation/models/validation.models.ts